import Repository from './Repository';

const resource = 'user';

export default {
  get() {
    return Repository.get('users')
  },
  createUser(payload) {
    return Repository.post(resource, payload)
  },
  getUser(userId) {
    return Repository.get(resource + '/' +userId)
  },
  updateUser(userId, payload) {
    return Repository.put(resource + '/' + userId, payload)
  },
  suspendUser(userId) {
    return this.updateUser(userId, {
      status: 'deactivated'
    });
  },
  activateUser(userId) {
    return this.updateUser(userId, {
      status: 'active'
    });
  },
  searchUsers(search) {
    let query = '?'

    if ('' !== search.name) {
      query += '&name='+search.name
    }

    if ('' !== search.email) {
      query += '&emails[]=' + search.email
    }

    return Repository.get('users' + query);
  },
  updatePassword(userId, newPassword) {
    return this.updateUser(userId, {
      password: newPassword
    });
  },
  resetPassword(email) {
    return Repository.post('user/reset-password', {email: email});
  },
  changePassword(userId, newPassword, hash) {
    return Repository.post(
      'user/' + userId + '/change-password',
      {password: newPassword, resetHash: hash}
      )
  }
}

